import { render, staticRenderFns } from "./uploadVideoDialog.vue?vue&type=template&id=239367fc&scoped=true"
import script from "./uploadVideoDialog.vue?vue&type=script&lang=js"
export * from "./uploadVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./uploadVideoDialog.vue?vue&type=style&index=0&id=239367fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239367fc",
  null
  
)

export default component.exports